import * as React from "react";
import Dispatcher from "../../Dispatcher";
import LoginStore from "./stores/LoginStore";
import { Authenticator } from "../../components/security";
import { Container } from "flux/utils";
import { ILoginViewProps, LoginView } from "./views/LoginView";
import { Location } from "history";
import { Redirect } from "react-router";

interface IProps
{
    location: Location;
}

interface IState extends ILoginViewProps
{
    redirectToReferrer: boolean;
}

class LoginContainer extends React.Component<IProps, IState> {

    public render(): React.ReactElement<any>
    {
        const { from } : any = this.props.location.state || { from: { pathname: "/" } };
        const { loginLoader } = this.state;

        if (Authenticator.isLoggedIn)
        {
            return <Redirect to={from} />;
        }

        return <LoginView {...this.state} />;
    }

    public static getStores()
    {
        return [
            LoginStore
        ];
    }

    public static calculateState(prevState)
    {
        return {
            loginLoader: LoginStore.getState().getLoadObject(),
            onLogin: LoginContainer.onLogin,
            logout: LoginContainer.logout
        };
    }

    private static onLogin(username: string, password: string)
    {
        Dispatcher.dispatch({
            type: "login/login",
            username,
            pwd: password
        });
    }

    private static logout()
    {
        Dispatcher.dispatch({
            type: "logout"
        });
    }
}

export default Container.create(LoginContainer);
